import styled from '@emotion/styled';
import breakpoints from '../../../../theme/material/breakpoints';
import { isDarkMode } from '../../../../utils/helpers';
import colors from '../../../../theme/colors';
import { getTextColor } from '../../../../style';

export const CameraPermissionContainer = styled('div')<{ isJoinFlow: boolean }>(({ isJoinFlow }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: isJoinFlow ? '-10px -60px 0 -60px' : '0 0',
  [breakpoints.down('md')]: {
    margin: isJoinFlow ? '-5px 10px 0px 10px' : '0 0',
  },
}));

export const InstructionContainer = styled('div')<{ isJoinFlow: boolean }>(({ isJoinFlow }) => ({
  display: 'flex',
  padding: '10px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '15px',
  borderRadius: '8px',
  width: '100%',
  background: !isJoinFlow && isDarkMode() ? '#113956' : 'rgba(234, 244, 251, 0.50)',
  marginBottom: 20,
}));

export const Title = styled('p')({
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 600,
  color: !isDarkMode() ? '#212121' : '#cfcfcf',
  lineHeight: '21px',
  margin: 0,
});

export const ListContainer = styled('ol')<{ isJoinFlow: boolean }>(({ isJoinFlow }) => ({
  marginBlockStart: '0em',
  marginBlockEnd: '0em',
  paddingInlineStart: '20px',
  gap: '10px',
  display: 'flex',
  flexDirection: 'column',
  color: isJoinFlow ? colors.light.gray.light : getTextColor().WHITE_GRAY.color,
  lineHeight: '20px',
}));

export const ImageWrapper = styled('div')({
  width: '100%',
  overflow: 'hidden',
});

export const refreshBtnStyle = {
  marginTop: 0,
  marginBottom: 20,
  width: 160,
  fontSize: '14px !important',
};

export const ImageStyle = styled('img')({
  width: '100%',
  height: 'auto',
});

export const ScanText = styled('p')<{ customStyle?: React.CSSProperties }>(({ customStyle }) => ({
  color: '#2B8FD7',
  textAlign: 'center',
  fontSize: 18,
  fontWeight: 700,
  lineHeight: '23px',
  letterSpacing: '-0.36px',
  margin: 0,
  ...customStyle,
}));

export const linkStyle = {
  color: '#2B8FD7',
  textDecorationLine: 'underline',
  textDecorationStyle: 'solid',
  textDecorationSkipInk: 'none',
  textDecorationThickness: 'auto',
  textUnderlineOffset: 'auto',
  textUnderlinePosition: 'from-font',
};
